import React from 'react';
import styles from './Permissions.scss';
import SideNav from 'pages/studyOverview/components/SideNav';
import lodash from 'lodash';
import { TwoColumnScaffold, LeftColumn, RightColumn } from 'pages/studyOverview/components/TwoColumnScaffold';
import { loadHomePageV4Access } from '../../../common/features/predicates';
import { connect } from 'react-redux';

export const resourceTypes = Object.freeze({
    study: 'study',
    binder: 'binder',
    institution: 'institution',
    document_type: 'document_type',
});

export const Permissions = (props) => {
    const sideNavLinks = [
        {
            to: '/admin/permissions/study',
            title: props.complion4FlagEnabled ? 'Binder' : 'Study'
        }
    ];

    return (
        <TwoColumnScaffold className={styles.scaffold}>
            <LeftColumn>
                <SideNav
                    links={sideNavLinks}
                    location={props.location}
                    activeIndex={() =>
                        lodash.findIndex(
                            sideNavLinks,
                            (link) => props.location.pathname.includes(link.to)
                        )
                    }
                />
            </LeftColumn>
            <RightColumn className={styles.rightColumn}>
                {props.children}
            </RightColumn>
        </TwoColumnScaffold>
    );
};

const mapStateToProps = state => ({
    complion4FlagEnabled: loadHomePageV4Access(state),
});

export default connect(mapStateToProps)(Permissions);
